module.exports = __webpack_public_path__ + "7072c7bc5eac1dc5c6252b14e66281a3.pdf";